// FILE: src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
// Inter, self-hosted: bundled with the app, no request to Google Fonts (WP-8).
import "@fontsource-variable/inter";

import { store } from "./store";
import ErrorBoundary from "./components/ErrorBoundary";
import App from "./App";
import SupportPromptDialog from "./components/SupportPromptDialog";
import theme, { MODE_STORAGE_KEY } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      {/* Light/dark follows the device until the student picks one (plan WP-8 task 5). */}
      <ThemeProvider theme={theme} defaultMode="system" modeStorageKey={MODE_STORAGE_KEY} disableTransitionOnChange>
        <CssBaseline enableColorScheme />
        <ErrorBoundary>
          <App />
          <SupportPromptDialog />
        </ErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);
